module.exports = __webpack_public_path__ + "static/media/try-andie-arrow-up-fr.d764f176.svg";